var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        "click:outside": function($event) {
          return _vm.$emit("close")
        }
      },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-row",
            [
              _c("v-card-title", { staticClass: "ml-5" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("invoicing.setInvoiceStatesDialog.title")) +
                    " "
                )
              ])
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: Object.values(_vm.salesInvoiceStates),
                          label: _vm.$t(
                            "invoicing.setInvoiceStatesDialog.salesInvoiceState"
                          )
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.salesInvoiceStatusToTranslationKey(
                                          data.item
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.salesInvoiceStatusToTranslationKey(
                                          data.item
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.newSalesInvoiceState,
                          callback: function($$v) {
                            _vm.newSalesInvoiceState = $$v
                          },
                          expression: "newSalesInvoiceState"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: Object.values(_vm.purchaseInvoiceStates),
                          label: _vm.$t(
                            "invoicing.setInvoiceStatesDialog.purchaseInvoiceState"
                          )
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.purchaseInvoiceStatusToTranslationKey(
                                          data.item
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.purchaseInvoiceStatusToTranslationKey(
                                          data.item
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.newPurchaseInvoiceState,
                          callback: function($$v) {
                            _vm.newPurchaseInvoiceState = $$v
                          },
                          expression: "newPurchaseInvoiceState"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "invoicing.setInvoiceStatesDialog.warningMessage"
                          )
                        ) +
                        " "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.isChangingStates, color: "primary" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.setStates($event)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }